<template>
  <main>
    <form @submit="onSubmit">
      <b-card>
        <h3 style="font-weight: bold">About Us</h3>
        <ckeditor v-model="content" :config="editorConfig"></ckeditor>
      </b-card>
      <b-button variant="primary" type="submit">{{
        loading ? "Saving" : "Save"
      }}</b-button>
    </form>
  </main>
</template>

<script>
/* eslint-disable */
import { BCard, BRow, BCol, BFormTextarea, BButton } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { editAboutUs, fetchAboutUs } from "@/service/api.service";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormTextarea,
  },

  data() {
    return {
      content: "",
      loading: false,
      data: null,
      editorData: "<p>Type about us here...</p>",
      editorConfig: {
        // The configuration of the editor.
      },
    };
  },
  created() {
    this.getAboutUs();
  },
  methods: {
    routeTo(path) {
      this.$router.push(path);
    },
    onSubmit(e) {
      e.preventDefault();
      console.log('content ', this.content)
      this.updateAboutUs();
    },
    getAboutUs() {
      fetchAboutUs()
        .then((res) => res.json())
        .then((response) => {
          if (response.valid) {
            this.data = response.data;
            this.content = this.data.content;
          }
        })
        .catch((e) => {
          this.showToast("Error", "danger", e);
        });
    },
    updateAboutUs() {
      this.loading = true;
      editAboutUs({ id: this.data.id, content: this.content })
        .then((res) => res.json())
        .then((response) => {
          this.loading = false;
          if (response.valid) {
            this.showToast(
              "Success",
              "success",
              "About Us updated successfully"
            );
          }
        })
        .catch((e) => {
          this.loading = false;
          this.showToast("Error", "danger", e);
        });
    },
    showToast(title, variant, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          text: text,
          icon: title === "Error" ? "TrashIcon" : "DoneIcon",
          variant: variant,
        },
      });
    },
  },
};
</script>

<style scoped></style>
